export enum RampType {
  AdjustableAluminumRamp2FootSections = 'adjustable-aluminum-ramp-2-foot-sections',
  AdjustableAluminumRamp = 'adjustable-aluminum-ramp',
  AdjustableWoodRamp1FootSections = 'adjustable-wood-ramp-1-foot-sections',
  AdjustableWoodRamp2FootSections = 'adjustable-wood-ramp-2-foot-sections',
  // TODO: migrate all diamond-ramp to wedge-ramp.
  DiamondRamp = 'diamond-ramp',
  Horizontal2x6WoodRamp = 'horizontal-2x6-wood-ramp',
  Ramp26 = 'ramp-2-6',
  WedgeRamp = 'wedge-ramp',
}
